import { render, staticRenderFns } from "./principleProfile.vue?vue&type=template&id=0de506ba&scoped=true&"
import script from "./principleProfile.vue?vue&type=script&lang=js&"
export * from "./principleProfile.vue?vue&type=script&lang=js&"
import style0 from "./principleProfile.vue?vue&type=style&index=0&id=0de506ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de506ba",
  null
  
)

export default component.exports